import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React, { useEffect, useState } from 'react';

import type { ComponentProps } from 'lib/component-props';
import compose from 'lib/enhancers/compose';
import withStyles from 'lib/enhancers/withStyles';

import type { ResponsiveImageFields } from 'models/responsive-image';

import styles from './CountdownBanner.module.scss';
import RichTextWrapper from 'components/helpers/RichText/RichTextWrapper';
import withValidDatasourceCheck from 'lib/enhancers/withValidDatasourceCheck';

type CountdownBannerFields = ResponsiveImageFields & {
  bannerBody: Field<string>;
  countdownDay: Field<string>;
};

type CountdownBannerProps = ComponentProps & {
  fields: CountdownBannerFields;
};

const cx = classNames.bind(styles);

const CountdownBanner = (props: CountdownBannerProps): React.JSX.Element => {
  const { className, fields } = props;
  const countdownTargetDate = fields.countdownDay.value;
  const [daysRemaining, setDaysRemaining] = useState(calculateDaysRemaining(countdownTargetDate));

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDaysRemaining(calculateDaysRemaining(countdownTargetDate));
    }, 1000 * 60 * 60 * 24); //Update every day

    return () => clearInterval(intervalId);
  }, [countdownTargetDate]);

  function calculateDaysRemaining(targetDate: string): number {
    const now = new Date();
    const target = new Date(targetDate);
    const difference = target.getTime() - now.getTime();

    if (difference <= 0) return 0;

    return Math.ceil(difference / (1000 * 60 * 60 * 24));
  }

  const replaceTokens = (text?: string) => {
    return text?.replaceAll('{countdown}', daysRemaining.toString()) ?? '';
  };

  return fields.bannerBody.value ? (
    <div className={cx('countdown-banner', 'component-container-edge', className)}>
      <RichTextWrapper className={cx('body')} field={{ value: replaceTokens(fields.bannerBody.value) }} />
    </div>
  ) : (
    <></>
  );
};

export default compose<CountdownBannerProps>(withValidDatasourceCheck(), withStyles())(CountdownBanner);
